// Mock data for users
export const mockUsers = [
    {
        id: "1",
        firstName: "Pieter",
        lastName: "de Vries",
        name: "Pieter de Vries",
        email: "pieter.devries@sitex.nl",
        userName: "pieterdevries",
        phoneNumber: "+31612345678",
        roleName: "Admin",
        groupNames: "Management",
        userGroupIds: "group-1",
        accountManager: "Laura van Dijk",
        accountManagerEmail: "laura.vandijk@sitex.nl",
        accountManagerContactNumber: "+31687654321",
        isActive: true,
        isLoggedInWithMicrosoft: true,
    },
    {
        id: "2",
        firstName: "Laura",
        lastName: "van Dijk",
        name: "Laura van Dijk",
        email: "laura.vandijk@sitex.nl",
        userName: "lauravandijk",
        phoneNumber: "+31623456789",
        roleName: "Manager",
        groupNames: "Operations",
        userGroupIds: "group-2",
        accountManager: "Pieter de Vries",
        accountManagerEmail: "pieter.devries@sitex.nl",
        accountManagerContactNumber: "+31612345678",
        isActive: true,
        isLoggedInWithMicrosoft: false,
    },
    {
        id: "3",
        firstName: "Jan",
        lastName: "Jansen",
        name: "Jan Jansen",
        email: "jan.jansen@sitex.nl",
        userName: "janjansen",
        phoneNumber: "+31634567890",
        roleName: "User",
        groupNames: "Support",
        userGroupIds: "group-3",
        accountManager: "Laura van Dijk",
        accountManagerEmail: "laura.vandijk@sitex.nl",
        accountManagerContactNumber: "+31687654321",
        isActive: false,
        isLoggedInWithMicrosoft: true,
    },
    {
        id: "4",
        firstName: "Sara",
        lastName: "Vermeer",
        name: "Sara Vermeer",
        email: "sara.vermeer@sitex.nl",
        userName: "saravermeer",
        phoneNumber: "+31645678901",
        roleName: "User",
        groupNames: "Development",
        userGroupIds: "group-4",
        accountManager: "Pieter de Vries",
        accountManagerEmail: "pieter.devries@sitex.nl",
        accountManagerContactNumber: "+31612345678",
        isActive: true,
        isLoggedInWithMicrosoft: false,
    },
];
// Filter options
export const nameOptions = [
    { value: "", label: "All Names" },
    { value: "pieter", label: "Pieter de Vries" },
    { value: "laura", label: "Laura van Dijk" },
    { value: "jan", label: "Jan Jansen" },
    { value: "sara", label: "Sara Vermeer" },
];
export const emailOptions = [
    { value: "", label: "All Emails" },
    { value: "pieter.devries@sitex.nl", label: "pieter.devries@sitex.nl" },
    { value: "laura.vandijk@sitex.nl", label: "laura.vandijk@sitex.nl" },
    { value: "jan.jansen@sitex.nl", label: "jan.jansen@sitex.nl" },
    { value: "sara.vermeer@sitex.nl", label: "sara.vermeer@sitex.nl" },
];
export const roleOptions = [
    { value: "", label: "Select Role" },
    { value: "3f2504e0-4f89-11d3-9a0c-0305e82c3301", label: "Admin" },
    { value: "c9bf9e57-1685-4c89-bafb-ff5af830be8a", label: "Manager" },
    { value: "1b4e28ba-2fa1-11d2-883f-0016d3cca427", label: "User" },
];
export const groupOptions = [
    { value: "", label: "All Groups" },
    { value: "Management", label: "Management" },
    { value: "Operations", label: "Operations" },
    { value: "Support", label: "Support" },
    { value: "Development", label: "Development" },
];
export const statusOptions = [
    { value: "", label: "All Status" },
    { value: "active", label: "Active" },
    { value: "inactive", label: "Inactive" },
];
export const userTypeOptions = [
    { value: "", label: "All User Types" },
    { value: "internal", label: "Internal User" },
    { value: "external", label: "External User" },
];
export const accountManagerOptions = [
    { value: "", label: "All Account Managers" },
    { value: "Pieter de Vries", label: "Pieter de Vries" },
    { value: "Laura van Dijk", label: "Laura van Dijk" },
];
